module.exports = __webpack_public_path__ + "img/portrait-aude-old.5978349.jpg";